import { EventHeroSection } from "widgets";
import { EventAboutSection } from "widgets";
import { EventScheduleSection } from "widgets";
import { PartnersSection } from "widgets";
import { EventVenueSection } from "widgets";
import { EventExpertsSection } from "widgets";
import { EventInfoSection } from "widgets";
import { EventQuestionsSection } from "widgets";
import { FormSection } from "widgets";
import FormImg from "../assets/FormImg.png";
import styles from "./EventPage.module.scss";

export const EventPage = () => {
  return (
    <div className={styles.pageContent}>
      <div className={styles.section}>
        <EventHeroSection />
      </div>
      <div className={styles.section} id="about">
        <EventAboutSection />
      </div>
      <div className={styles.section} id="program">
        <EventScheduleSection />
      </div>
      <div className={styles.section} id="partners">
        <PartnersSection />
      </div>
      <div className={styles.section} id="venue">
        <EventVenueSection />
      </div>
      <div className={styles.section} id="experts">
        <EventExpertsSection />
      </div>
      <div className={styles.section}>
        <EventInfoSection />
      </div>
      <div className={styles.section} id="questions">
        <EventQuestionsSection />
      </div>
      <div className={styles.section}>
        <FormSection formTitle="Обратная связь" formImg={FormImg} />
      </div>
    </div>
  );
};
